import { KeycloakInstance } from 'keycloak-js';
import { useContext, useContextSelector } from 'use-context-selector';
import { KeycloakContext } from './KeycloakContext';
import { IAuthContextProps, IKeycloakProviderState, AuthClient } from './types';

const useKeycloakProviderState = (): IKeycloakProviderState<any> => {
  const context = useContext(KeycloakContext);

  if (context === undefined) {
    throw new Error('useKeycloakProviderState must be used within KeycloakProvider');
  }

  return context as IKeycloakProviderState<AuthClient>;
};

const useKeycloakTokens = () => {
  const context = useContextSelector(KeycloakContext, state => ({
    token: state.authClient?.token,
    idToken: state.authClient?.idToken,
    refreshToken: state.authClient?.refreshToken,
  }));

  if (context === undefined) {
    throw new Error('useKeycloakTokens must be used within KeycloakProvider');
  }

  return context;
};

const useKeycloak = (initialContext?: Partial<IAuthContextProps<KeycloakInstance>> | undefined) => {
  const context = useContextSelector(KeycloakContext, state => ({
    keycloak: state.authClient,
    initialized: state.initialized,
    authenticated: state.isAuthenticated,
  }));

  if (context === undefined) {
    throw new Error('useKeycloak must be used within KeycloakProvider');
  }

  if (!context.keycloak) {
    throw new Error('authClient has not been assigned to KeycloakProvider');
  }

  return context;
};

const useSetSelectedCustomerId = () => {
  const context = useContextSelector(KeycloakContext, state => state.onSelectCustomerId);

  if (context === undefined) {
    throw new Error('useSetSelectedCustomerId must be used within KeycloakProvider');
  }

  return context;
};

export { useKeycloakProviderState, useKeycloakTokens, useKeycloak, useSetSelectedCustomerId };
